export function size(state) {
  return state.size;
}
export function isMobileDevice(state) {
  return state.size.width < 600 || state.size.height < 600;
}

export function dark(state) {
  return state.dark;
}

export function mini(state) {
  return state.mini;
}

export function declinedPWA(state) {
  return state.declinedPWA;
}

export function installedPWA(state) {
  return state.installedPWA;
}

export function platform(state) {
  return null;//state.platform;
}

export function connected(state) {
  return state.connected;
}

export function loading(state) {
  return state.activeRequests >= 1;
}

export function sysNotifications(state) {
  return state.sysNotifications;
}

export function updateInProgress(state) {
  return state.updateInProgress;
}